<template>
  <div class="content">
    <h1 class="font-light">Confirm New Password</h1>
    <div class="divider u-no-margin"></div>
    <div class="panel">
      To reset your password type your new password into the boxes below and
      click <i>submit</i>.
    </div>
    <div class="form-section">
      <!-- Password field -->
      <div class="row ignore-screen level">
        <div class="offset-2 col-10 error" v-if="error.new_password">
          {{ error.new_password }}
        </div>
        <div class="col-2 level-item font-bold">
          <span class="u-fill-width">Password:</span>
        </div>
        <div class="col-10 level-item input-control">
          <input
            v-model="formData.new_password"
            v-bind:class="{ 'input-error': error.new_password }"
            class="input-contains-icon"
            type="password"
            placeholder="Super Secret Password"
          />
          <span class="icon">
            <i class="fa fa-wrapper fa-key"></i>
          </span>
        </div>
      </div>
      <!-- Re-Password field -->
      <div class="row ignore-screen level">
        <div class="offset-2 col-10 error" v-if="error.re_new_password">
          {{ error.re_new_password }}
        </div>
        <div class="col-2 level-item font-bold">
          <span class="u-fill-width">Re-type Password:</span>
        </div>
        <div class="col-10 level-item input-control">
          <input
            v-model="formData.re_new_password"
            v-bind:class="{ 'input-error': error.re_new_password }"
            class="input-contains-icon"
            type="password"
            placeholder="How well can you type?"
          />
          <span class="icon">
            <i class="fa fa-wrapper fa-key"></i>
          </span>
        </div>
      </div>
      <space></space>
      <div class="row">
        <div class="u-text-right u-fill-width">
          <button
            class="btn-primary u-pull-right --tas-button-side-margin"
            v-on:click="submitForm"
          >
            <loading-spinner v-show="submit"></loading-spinner>
            <i
              class="fa-wrapper fa fa-paper-plane pad-right"
              v-show="!submit"
            ></i>
            Submit
          </button>
        </div>
      </div>
    </div>
    <!-- Success -->
    <div class="toast toast--success" v-show="success">
      <button class="btn-close" v-on:click="closeSuccess"></button>
      <h6>Password Changed</h6>
      <p>
        Your password has been changed. You'll be redirected back to the login
        page in a few seconds, or
        <router-link :to="{ name: 'login' }"> click here</router-link> to login
      </p>
    </div>
    <!-- Other field errors -->
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="section" v-if="error.uid || error.token">
      <div class="toast toast--error">
        <button class="btn-close" v-on:click="closeError"></button>
        <h6>Error: Could Not Change Password</h6>
        <div v-if="error.uid">
          <strong>Uid: </strong> <span v-html="error.uid"></span>
        </div>
        <div v-if="error.token">
          <strong>Token: </strong> <span v-html="error.token"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.--tas-button-side-margin {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>
<script>
import { mapGetters } from "vuex";
import * as authService from "@/services/auth.service";
import { handleError } from "@/functions/handleError.function";
import ServerError from "@/components/ServerError";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "reset-password-confirm",
  components: {
    ServerError,
    LoadingSpinner
  },
  data: function() {
    return {
      formData: {
        uid: "",
        token: "",
        new_password: "",
        re_new_password: ""
      },
      submit: false,
      success: false,
      successEmail: ""
    };
  },
  computed: {
    ...mapGetters("core", ["error"])
  },
  methods: {
    validate() {
      let is_valid = true;
      for (let field in this.formData) {
        if (this.formData[field] == "") {
          is_valid = false;
          let data = {};
          data[field] = "This field may not be blank";
          this.$store.commit("core/setError", data);
        }
        if (this.formData.new_password != this.formData.re_new_password) {
          is_valid = false;
          let data = { re_new_password: "Password's don't match. " };
          this.$store.commit("core/setError", data);
        }
      }
      return is_valid;
    },
    submitForm() {
      this.$store.commit("core/clearErrors");
      this.submit = true;
      this.success = false;
      // Parse the url params into the formData
      this.formData["uid"] = this.$route.params.uid;
      this.formData["token"] = this.$route.params.token;
      let is_valid = this.validate();
      if (!is_valid) {
        this.submit = false;
        return;
      }
      // Call the auth.service directly as this never interacts with the Vuex
      // store
      authService
        .resetPasswordConfirm(this.formData)
        .then(response => {
          this.submit = false;
          if (response.status == 204) {
            this.successEmail = response.data.email;
            this.success = true;
            // Wait 5 seconds then re-direct to the login page
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, 5000);
          }
        })
        .catch(error => {
          this.submit = false;
          let data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    closeSuccess: function() {
      this.success = false;
    },
    closeError: function() {
      this.$store.commit("core/setError", { uid: "", token: "" });
    }
  },
  mounted() {
    this.$store.commit("core/clearErrors");
  }
};
</script>
